import { render, staticRenderFns } from "./ResponsiveVimeo.vue?vue&type=template&id=78710e0a&scoped=true&"
import script from "./ResponsiveVimeo.vue?vue&type=script&lang=js&"
export * from "./ResponsiveVimeo.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveVimeo.vue?vue&type=style&index=0&id=78710e0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78710e0a",
  null
  
)

export default component.exports